import { render, staticRenderFns } from "./DistributorList.vue?vue&type=template&id=03f238c1&"
import script from "./DistributorList.vue?vue&type=script&lang=js&"
export * from "./DistributorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports